// Create a new file publicApi.js
import axios from 'axios'
import { getBackendUrl } from '../config';

const publicApi = axios.create({
  baseURL: getBackendUrl(),
  timeout: 8000,
});

export default publicApi;